import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const messageSlice = createSlice({
    name: "message",
    initialState,
    reducers: {
        setMessage: (state, action) => {
            return { message: action.payload };
        },
        setMessageStatus: (state, action) => {
            return { messageStatus: action.payload };
        },
        clearMessage: () => {
            return { message: "", messageStatus :"" };
        },
    },
});

const { reducer, actions } = messageSlice;

export const { setMessage, clearMessage, setMessageStatus } = actions
export default reducer;